module.exports = __webpack_public_path__ + "img/admin.d3fed872.jpg";